import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCustomThemeAdminFlag = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-custom-theme-admin-flag" */ './index'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<JSErrorBoundary id="async.jira.custom-theme-admin-flag" packageName="customThemeAdminFlag">
		<Placeholder name="custom-theme-admin-flag" fallback={null}>
			<LazyCustomThemeAdminFlag />
		</Placeholder>
	</JSErrorBoundary>
);
